import React, { useContext } from "react";

import person1Png from "../../assets/Persons/person1.png";
import person1Webp from "../../assets/Persons/person1.webp";
import person2Png from "../../assets/Persons/person2.png";
import person2Webp from "../../assets/Persons/person2.webp";
import person3Png from "../../assets/Persons/person3.png";
import person3Webp from "../../assets/Persons/person3.webp";
import person4Png from "../../assets/Persons/person4.png";
import person4Webp from "../../assets/Persons/person4.webp";
import backgroundPng from "../../assets/background.png";
import backgroundWebp from "../../assets/background.webp";
// import { ReactComponent as DocumentsList } from "../../assets/documentsList.svg";
import DocumentsListPng from "../../assets/documentList.png";
import DocumentsListWebp from "../../assets/documentList.webp";
import { TransitionContext } from "../../Context/TransitionContext";

import AlbaniaFlag from "../../assets/flags/AlbaniaFlag.png";
import UAEFlag from "../../assets/flags/UAEFlag.png";
import ArmeniaFlag from "../../assets/flags/ArmeniaFlag.png";
import BangladeshFlag from "../../assets/flags/BangladeshFlag.png";
import BosniaFlag from "../../assets/flags/BosniaFlag.png";
import BulgariaFlag from "../../assets/flags/BulgariaFlag.png";
import MyanmarFlag from "../../assets/flags/MyanmarFlag.png";
import SpainFlag from "../../assets/flags/SpainFlag.png";
import ChinaFlag from "../../assets/flags/ChinaFlag.png";
import CreoleFlag from "../../assets/flags/CreoleFlag.png";
import USAFlag from "../../assets/flags/USAFlag.png";
import iranFlag from "../../assets/flags/iranFlag.png";
import finlandFlag from "../../assets/flags/finlandFlag.png";
import franceFlag from "../../assets/flags/franceFlag.png";
import canadaFlag from "../../assets/flags/canadaFlag.png";
import georgiaFlag from "../../assets/flags/georgiaFlag.png";
import germanyFlag from "../../assets/flags/germanyFlag.png";
import GreekFlag from "../../assets/flags/GreekFlag.png";
import IndianFlag from "../../assets/flags/IndianFlag.png";
import israelFlag from "../../assets/flags/israelFlag.png";
import { lazySvg } from "../../utility/lazySvg";

// Phones only; loads apart from the page code (see lazySvg).
const SmalldocumentsList = lazySvg(() => import("../../assets/smalldocumentsList.svg"), { width: "335", height: "448", viewBox: "0 0 335 448" });
const Languages = ({ showMostPopularDocuments = true }) => {
  // WebP copies (portraits 13-22 KB instead of 65-97 KB, the background
  // 10 KB instead of 224 KB, the list lossless 85 KB instead of 142 KB);
  // browsers without WebP keep the PNGs.
  const { webP } = useContext(TransitionContext);
  const png = webP === "png";
  const person1 = png ? person1Png : person1Webp;
  const person2 = png ? person2Png : person2Webp;
  const person3 = png ? person3Png : person3Webp;
  const person4 = png ? person4Png : person4Webp;
  const background = png ? backgroundPng : backgroundWebp;
  const DocumentsList = png ? DocumentsListPng : DocumentsListWebp;
  // Kept in alphabetical order, and laid out column-first by CSS below.
  // It used to be stored interleaved (Albanian, English, Arabic, Farsi...) so
  // that a two-column grid filling row by row would *read* alphabetically down
  // each column. On mobile that grid collapses to one column, and the stored
  // order is what the visitor sees - which is why the mobile list looked
  // shuffled. Sorting the data and letting the grid flow by column fixes the
  // phone without changing the desktop.
  const LanguageData = [
    { flag: AlbaniaFlag, language: "Albanian" , page: "/languages/albanian-to-english-translation" },
    { flag: UAEFlag, language: "Arabic" , page: "/languages/arabic-to-english-translation" },
    { flag: ArmeniaFlag, language: "Armenian" , page: "/languages/armenian-to-english-translation" },
    { flag: BangladeshFlag, language: "Bengali" , page: "/languages/bengali-to-english-translation" },
    { flag: BosniaFlag, language: "Bosnian" , page: "/languages/bosnian-to-english-translation" },
    { flag: BulgariaFlag, language: "Bulgarian" , page: "/languages/bulgarian-to-english-translation" },
    { flag: MyanmarFlag, language: "Burmese" , page: "/languages/burmese-to-english-translation" },
    { flag: SpainFlag, language: "Catalan" , page: "/languages/catalan-to-english-translation" },
    { flag: ChinaFlag, language: "Chinese (Simplified)" , page: "/languages/chinese-to-english-translation" },
    { flag: ChinaFlag, language: "Chinese (Traditional)" , page: "/languages/chinese-to-english-translation" },
    // Was a second "Catalan" carrying the Creole flag: the label was wrong,
    // not the flag. Creole is on the order form; Catalan was listed twice.
    { flag: CreoleFlag, language: "Creole" , page: "/languages/haitian-creole-to-english-translation" },
    { flag: USAFlag, language: "English" },
    { flag: iranFlag, language: "Farsi" , page: "/languages/persian-to-english-translation" },
    { flag: finlandFlag, language: "Finnish" , page: "/languages/finnish-to-english-translation" },
    { flag: franceFlag, language: "French" , page: "/languages/french-to-english-translation" },
    { flag: canadaFlag, language: "French (Canadian)" , page: "/languages/french-to-english-translation" },
    { flag: georgiaFlag, language: "Georgian" , page: "/languages/georgian-to-english-translation" },
    { flag: germanyFlag, language: "German" , page: "/languages/german-to-english-translation" },
    { flag: GreekFlag, language: "Greek" , page: "/languages/greek-to-english-translation" },
    { flag: IndianFlag, language: "Gujrati" , page: "/languages/gujarati-to-english-translation" },
    { flag: israelFlag, language: "Hebrew" , page: "/languages/hebrew-to-english-translation" },
    { flag: IndianFlag, language: "Hindi" , page: "/languages/hindi-to-english-translation" },
  ];

  const PersonList = [
    {
      image: person1,
    },
    {
      image: person2,
    },
    {
      image: person3,
    },
    {
      image: person4,
    },
  ];


  return (
    <div className="pt-20" id="languages">
      <div className="space-y-8">
        <div className=" grid grid-cols-1 lg:grid-cols-2 gap-5">
          <div className="flex flex-col h-full justify-between lg:py-20 lg:px-8 p-4 gap-8">
            <h2 className="font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-left ">
              Translations in <br />
              <span className="text-primary">over 60+</span>
              <br /> languages
            </h2>
            <div className="flex flex-col gap-4">
              <div>
                <ul className="flex items-center">
                  {PersonList.map((person, index) => (
                    <li
                      key={index}
                      className="h-12 w-12 border-4 border-[#EFF3F5] rounded-full overflow-hidden -mr-3"
                    >
                      <img
                        src={person.image}
                        alt="person"
                        width="200"
                        height="200"
                        loading="lazy"
                        decoding="async"
                        className="max-h-full max-w-full"
                      />
                    </li>
                  ))}
                </ul>
              </div>
              <p className="lg:text-tertiary text-[#686F7B] text-base text-left xl:w-1/2 w-full">
                We work with a team of highly qualified, full-time translators,
                ensuring consistent quality across every language we offer.
              </p>
            </div>
          </div>
          <div className="bg-white rounded-4xl overflow-hidden shadow-sm py-8">
            <div className="grid grid-cols-1 md:grid-flow-col md:grid-rows-[repeat(11,minmax(0,1fr))] gap-5 md:max-h-full max-h-[500px] md:overflow-hidden overflow-y-scroll px-8">
              {LanguageData.map((item, index) => (
                <div
                  key={index}
                  className="flex gap-3 items-center justify-between"
                >
                  <div className="flex gap-2 items-center">
                    <span className="text-xl">
                      <img
                        src={item.flag}
                        alt={item.flag}
                        loading="lazy"
                        decoding="async"
                        className="h-6 w-6"
                      />
                    </span>
                    {/* The grid used to be sixty labels of plain text. Someone
                        reading a list of languages is still deciding whether we
                        handle theirs, so the link goes to that language's page -
                        which answers that - rather than straight to checkout. */}
                    {item.page ? (
                      <a href={item.page} className="text-xl hover:underline">
                        {item.language}
                      </a>
                    ) : (
                      <span className="text-xl">{item.language}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

       { showMostPopularDocuments && <div
          style={{ backgroundImage: `url(${background})` }}
          className="overflow-hidden rounded-4xl bg-cover bg-center mt-5 space-y-8 "
        >
          <div className="flex flex-col gap-4 items-center md:p-8 p-4 mt-10">
            <h2 className="font-secondary font-medium md:text-5xl text-4xl text-white uppercase text-center ">
              Most Popular Documents
            </h2>
            <p className="text-[#BDC1C9] text-base text-center xl:w-[30%] md:w-1/2 w-full">
              The most popular documents for translation. Get your standard or
              certified translations quickly and accurately.
            </p>
          </div>

          <div className="w-full flex justify-center">
            <img
              src={DocumentsList}
              width="1312"
              height="351"
              loading="lazy"
              decoding="async"
              className="max-h-full max-w-full bg-no-repeat size-full sm:block hidden"
              alt=""
            />
            <SmalldocumentsList className="max-h-full max-w-full bg-no-repeat size-full sm:hidden block " />
          </div>
        </div>}
      </div>
    </div>
  );
};

export default Languages;
